
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class PromotionMasterGrid extends Serenity.EntityGrid<PromotionMasterRow, any> {
        protected getColumnsKey() { return 'OMS.PromotionMaster'; }
        protected getDialogType() { return PromotionMasterDialog; }
        protected getIdProperty() { return PromotionMasterRow.idProperty; }
        protected getInsertPermission() { return PromotionMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return PromotionMasterRow.localTextPrefix; }
        protected getService() { return PromotionMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}